import React from 'react';
import { ApplyContext } from './apply-context';

export function withApplyContext(Component) {
  return function WrappedComponent(props) {
    return (
      <ApplyContext.Consumer>
        {context => <Component {...props} {...context} />}
      </ApplyContext.Consumer>
    );
  }
};
